import {Box, Button, ButtonGroup, Flex, HStack, useToken} from '@chakra-ui/react';
import React, {useEffect, useState} from 'react';
import {atom, useRecoilState} from 'recoil';
import {CloseIcon} from '@chakra-ui/icons';
// import { isMobileState } from '../../../providers/recoil/global';
import MenuKit from '../../../components/kits/Menu';
import {BsFillGridFill} from 'react-icons/bs';
import {FaList} from 'react-icons/fa';
import {motion} from 'framer-motion';
import Container from "../../../components/Container";
import axios from "axios";
import {htmlDecode} from "../../../utils/htmlDecode";
import {useLocation, useSearchParams, useNavigate} from "react-router-dom";
import {selectedCompany} from "./company-detail";
import { set } from 'lodash';

const companyViewState = atom({
    key: 'companies-nav__view',
    default: 'grid',
});

const initialState = {
    featured: false,
    technology: null,
    private_healthcare: null,
    investment_status: false,
    alumni: false,
    firstInvestment: null,
};

const companyFilterState = atom({
    key: 'companies-nav__filter',
    default: {
        featured: 'Featured',
        technology: null,
        private_healthcare: null,
        investment_status: false,
        alumni: false,
        firstInvestment: null,
    },
});

let portfolioInitialized = false;

let sectorOptions = {};

const PortfolioNav = (props) => {
    const location = useLocation();
    const [view, setView] = useRecoilState(companyViewState);
    const [filter, setFilter] = useRecoilState(companyFilterState);
    const [openFilter, setOpenFilter] = useState(false);
    // const isMobileView = useRecoilValue(isMobileState);
    const brand700 = useToken('color', ['brand.700']);
    const [searchParams, setSearchParams] = useSearchParams();
    const activeSector = searchParams.get('sector');
    const showAll = searchParams.get('show');
    const statusFlag = searchParams.get('status');
    const series = searchParams.get('series');
    const [companyDetail, setCompanyDetail] = useRecoilState(selectedCompany);
    const [initialDropdownValue, setInitialDropdownValue] = useState('Featured')
    const [statusDropdownValue, setStatusDropdownValue] = useState('Status')
    const [techOptions, setTechOptions] = useState(sectorOptions['technology'] || [])
    const [technologyDropdown, setTechnologyDropdown] = useState(sectorOptions['techDropdown'] || undefined)
    const [healthDropdown, setHealthDropdown] = useState(sectorOptions['healthDropdown'] || undefined)
    const [healthOptions, setHealthOptions] = useState(sectorOptions['healthcare'] || [])
    const {state: pageState} = useLocation();
    const navigate = useNavigate();

    // console.log('trying to get company list', companies);

    const scrollToTop = () => {
        const filters = document.getElementsByClassName("companies-filter");
        // console.log('filters', filters);
        window.scrollTo({
            top: filters[0].offsetTop - 20,
            behavior: "smooth"
        });
    };

    const scrollToVeryTop = () => {
        // console.log('filters', filters);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    // tests the slug situation whenever the path changes
    useEffect(() => {
        // get slug
        // console.log('portfolioNav 1', showAll, activeSector); //, window.performance.memory.usedJSHeapSize);
        
        let slug = false;
        if(location?.pathname !== '/companies/' &&  location?.pathname !== '/companies') {
            slug = location?.pathname.substring('/companies/'.length);
        }

        // console.log("testing if there is a slug", slug);
        if (showAll) {
            searchParams.delete('sector')
            // setSearchParams(searchParams);
            setInitialDropdownValue(undefined)
            setStatusDropdownValue(undefined)
            setFilter(initialState);
            /*
            setFilter((f) => {
                return({
                    ...f,

                })
            })
            */
            // scrollToTop();
            let temp = searchParams;
            temp.show = 'all';
            setSearchParams(temp);
        } else if(activeSector) {
            if (techOptions?.length > 0 && activeSector) {
                // eslint-disable-next-line no-unused-expressions
                techOptions?.map((opt) => {
                    if (htmlDecode(opt.value.toLowerCase()) === htmlDecode(activeSector.toLowerCase())) {
                        setInitialDropdownValue(undefined)
                        setStatusDropdownValue(undefined)
                        setFilter(() => ({
                            ...initialState,
                            technology: opt.title,
                        }))
                        // scrollToTop();
                    }
                })
            }
            if (healthOptions?.length > 0 && activeSector) {
                // eslint-disable-next-line no-unused-expressions
                healthOptions?.map((opt) => {
                    if (htmlDecode(opt.value.toLowerCase()) === htmlDecode(activeSector.toLowerCase())) {
                        setInitialDropdownValue(undefined)
                        setStatusDropdownValue(undefined)
                        setFilter(() => ({
                            ...initialState,
                            private_healthcare: opt.title,
                        }))
                        // scrollToTop();
                    }
                    return opt
                })
            }
        } else if (!portfolioInitialized && (location?.pathname && ['/companies/', '/companies'].includes(location?.pathname)) && !activeSector && !showAll) {
            setFilter(() => ({
                featured: 'Featured',
                technology: null,
                private_healthcare: null,
                investment_status: false,
                alumni: false,
                firstInvestment: null,
            }))
            // portfolioInitialized = true;
        } 
        
        // set state for status flag and series
        if(series) {
            setFilter((s) => ({
                ...s,
                firstInvestment: series
            }))
        }
        if(statusFlag) {
            setStatusDropdownValue(statusFlag)
            if(statusFlag == 'Active') {
                setFilter((s) => ({
                    ...s,
                    alumni: false,
                    investment_status: true
                }));
            } else if(statusFlag == 'Alumni') {
                setFilter((s) => ({
                    ...s,
                    alumni: true,
                    investment_status: false
                }));
            }
        }
        
        /* 
        else if ((!portfolioInitialized && location?.pathname !== '/companies/') ) {
            setInitialDropdownValue(undefined)
            setStatusDropdownValue(undefined)
            setFilter(() => (initialState))
            scrollToTop();
            // portfolioInitialized = true;
        }
        */
        // console.log("pageState", pageState);
        if( pageState?.comingFrom == 'home' || pageState?.comingFrom == 'nav') {    
            scrollToTop();
        } else if(pageState?.comingFrom == 'header' || pageState?.comingFrom == 'footer') {
            scrollToVeryTop();
        }
        /*
        
        let time = setTimeout(function() {
            console.log('testing slug', slug, document.getElementsByClassName('company-' +slug));
            if(slug){ //&& document.getElementsByClassName('company-' +slug).length == 0) {
                setInitialDropdownValue(undefined)
                setStatusDropdownValue(undefined)
                setFilter(() => (initialState))
                scrollToTop();
                // portfolioInitialized = true;
            }
        }, 250);
        */
        return () => {
            // clearTimeout(time);
        }
    // }, [location.pathname, setFilter])
    }, [location.pathname, searchParams, techOptions.length, healthOptions.length])

    // if an active sector is set, update the filter appropriately
    /*
    useEffect(() => {
        // console.log(activeSector, "activeSector")
        // console.log(techOptions?.length, "techOptions")
        // console.log(healthOptions?.length, "healthOptions")
        // console.log('portfolioNav 3', window.performance.memory.usedJSHeapSize);
        
        if (techOptions?.length > 0 && activeSector) {
            // eslint-disable-next-line no-unused-expressions
            techOptions?.map((opt) => {
                if (htmlDecode(opt.value.toLowerCase()) === htmlDecode(activeSector.toLowerCase())) {
                    setInitialDropdownValue(undefined)
                    setStatusDropdownValue(undefined)
                    setFilter(() => ({
                        ...initialState,
                        technology: opt.title,
                    }))
                    scrollToTop();
                }
            })
        }
        if (healthOptions?.length > 0 && activeSector) {
            // eslint-disable-next-line no-unused-expressions
            healthOptions?.map((opt) => {
                if (htmlDecode(opt.value.toLowerCase()) === htmlDecode(activeSector.toLowerCase())) {
                    setInitialDropdownValue(undefined)
                    setStatusDropdownValue(undefined)
                    setFilter(() => ({
                        ...initialState,
                        private_healthcare: opt.title,
                    }))
                    scrollToTop();
                }
                return opt
            })
        }
    // }, [activeSector])
    }, [activeSector, techOptions, healthOptions, setFilter, companyDetail])
    */

    // if showAll, update the filter appropriately
    /*
    useEffect(() => {
        if (showAll) {
            searchParams.delete('sector')
            // setSearchParams(searchParams);
            setInitialDropdownValue(undefined)
            setStatusDropdownValue(undefined)
            setFilter(initialState);
            scrollToTop();
            setSearchParams({
                show: 'all'
            })
        }
        
    // }, [activeSector])
    }, [showAll, setFilter, location.pathname])
    */
    // fetch the tech options, should only happen once
    useEffect(() => {
        // console.log('portfolioNav 4', window.performance.memory.usedJSHeapSize);
        
        const abortController = new AbortController();
        // console.log('getting tech options')
        const fetchData1 = async () => {
            if (!sectorOptions.hasOwnProperty('technology')) {
                sectorOptions['technology'] = await axios.get(`/wp-json/wp/v2/sector?_fields[]=slug&_fields[]=name&_fields[]=count&per_page=100&parent=7`, {signal: abortController.signal}).then(resp => {
                    let retval = [];
                    for(let i = 0; i < resp.data.length; i++) {
                        if(resp.data[i].slug != 'other' && resp.data[i].slug != 'sustainability' && resp.data[i].slug != 'computing-semi') {
                            retval.push(resp.data[i]);
                        }
                    }
                    return retval;
                });
                if (sectorOptions['technology'].length > 0) {
                    techOptions.push({title: 'All Technology', value: 'all-technology'});
                    for(let i = 0; i < sectorOptions['technology'].length; i++) {
                        techOptions.push({title: htmlDecode(sectorOptions['technology'][i].name), value: htmlDecode(sectorOptions['technology'][i].slug)})
                    }
                    /*
                    setTechOptions([
                        ...techOptions,
                        ...sectorOptions['technology']?.map((opt) => {
                            return {
                                title: htmlDecode(opt.name), value: htmlDecode(opt.slug)
                            }
                        }) 
                    ])
                    */
                    sectorOptions['technology'] = techOptions;
                    if (techOptions?.length > 0) {
                        const techOptionsData = techOptions?.map((item) => ({
                            ...item,
                            onClick: () => {
                                navigate(`/companies?sector=${item.value}`, { state: { comingFrom: "nav" } });
                                /*
                                setInitialDropdownValue(undefined)
                                setFilter(() => ({
                                    ...initialState,
                                    technology: item.title,
                                }))
                                scrollToTop();192.168.0.132
                                setSearchParams({
                                    sector: htmlDecode(item.value)
                                })
                                */
                            }
                        }))
                        sectorOptions['techDropdown'] = techOptionsData;
                        setTechnologyDropdown(
                            techOptionsData
                        )
                    }
                }
            }
        }
        fetchData1()
        return () => {
            abortController.abort();
        }
    
    }, []);

    // fetch the healthcare options, should only happen once
    useEffect(() => {
        // console.log('portfolioNav 5', window.performance.memory.usedJSHeapSize);
        
        const abortController2 = new AbortController();
        // console.log('getting health options')
        const fetchData = async () => {
            if (healthOptions.length == 0) {
                sectorOptions['healthcare'] = await axios.get(`/wp-json/wp/v2/sector?_fields[]=slug&_fields[]=name&_fields[]=count&per_page=100&parent=6`, {signal: abortController2.signal}).then(resp => {
                    let retval = [];
                    for(let i = 0; i < resp.data.length; i++) {
                        if(resp.data[i].slug != 'other' && resp.data[i].slug != 'sustainability' && resp.data[i].slug != 'computing-semi') {
                            retval.push(resp.data[i]);
                        }
                    }
                    return retval;
                });
                
                if (sectorOptions['healthcare']?.length > 0) {
                    healthOptions.push({title: 'All Healthcare', value: 'all-health'});
                    for(let i = 0; i < sectorOptions['healthcare'].length; i++) {
                        healthOptions.push({title: htmlDecode(sectorOptions['healthcare'][i].name), value: htmlDecode(sectorOptions['healthcare'][i].slug)})
                    }
                    /*
                    setHealthOptions([
                        ...healthOptions,
                        ...healthData?.map((opt) => {
                            return {
                                title: htmlDecode(opt.name), value: htmlDecode(opt.slug)
                            }
                        })
                    ])
                    */
                    sectorOptions['healthcare'] = healthOptions;
                    if (healthOptions?.length > 0) {
                        const healthOptionsData = healthOptions?.map((item) => ({
                            ...item,
                            onClick: () => {
                                navigate(`/companies?sector=${item.value}`, { state: { comingFrom: "nav" } });
                                /*companies
                                    setInitialDropdownValue(undefined)
                                    setFilter(() => ({
                                        ...initialState,
                                        private_healthcare: item.title,
                                    }))
                                    scrollToTop();
                                    setSearchParams({
                                        sector: htmlDecode(item.value)
                                    })
                                */
                            }
                        }))
                        sectorOptions['healthDropdown'] = healthOptionsData;
                        setHealthDropdown(
                            healthOptionsData
                        )
                    }
                }
            }
        }
    
        fetchData()
        return () => {
            abortController2.abort();
        }
    }, [])

    // If featured is set, update appropriately
    useEffect(() => {
        // console.log('portfolioNav 2', window.performance.memory.usedJSHeapSize);
        
        if (filter.featured === 'Featured') {
            setInitialDropdownValue(filter.featured)
            setStatusDropdownValue(undefined)
        }
    }, [filter])

    /*
    useEffect(() => {
        // console.log('portfolioNav 6', window.performance.memory.usedJSHeapSize);
        
        if (techOptions?.length > 0) {
            const techOptionsData = techOptions?.map((item) => ({
                ...item,
                onClick: () => {
                    setInitialDropdownValue(undefined)
                    setFilter(() => ({
                        ...initialState,
                        technology: item.title,
                    }))
                    scrollToTop();
                    setSearchParams({
                        sector: htmlDecode(item.value)
                    })
                }
            }))
            setTechnologyDropdown(
                techOptionsData
            )
        }
    }, [setFilter, setSearchParams, techOptions])

    useEffect(() => {
        // console.log('portfolioNav 7', window.performance.memory.usedJSHeapSize);
        
        if (healthOptions?.length > 0) {
            const healthOptionsData = healthOptions?.map((item) => ({
                ...item,
                onClick: () => {
                    setInitialDropdownValue(undefined)
                    setFilter(() => ({
                        ...initialState,
                        private_healthcare: item.title,
                    }))
                    scrollToTop();
                    setSearchParams({
                        sector: htmlDecode(item.value)
                    })
                }
            }))
            setHealthDropdown(
                healthOptionsData
            )
        }
    }, [healthOptions, setFilter, setSearchParams])
    */

    const firstInvestmentDropdown = [
        {title: 'Seed', value: 'Seed'},
        {title: 'Series A', value: 'Series A'},
        {title: 'Series B+', value: 'Series B'},
        // {title: 'Series C', value: 'Series C'},
    ].map((item) => ({
        ...item,
        onClick: () => {
            const hasFilter = showAll || activeSector;
            navigate(`/companies${(activeSector? `?sector=${activeSector}` : '')}${(showAll? `?show=all` : '')}${(hasFilter ? '&' : '?')}series=${item.value}`)
            /*
            setInitialDropdownValue(undefined)
            setStatusDropdownValue(undefined)
            setFilter((s) => {
                let temp = {...s};
                temp.firstInvestment = item.value;
                return temp;
            })
            scrollToTop();
            */
        }
    }));

    
    const statusDropdown = [
        {title: 'Active', value: 'Active'},
        {title: 'Alumni', value: 'Alumni'},
    ].map((item) => ({
        ...item,
        onClick: () => {
            // searchParams.delete('sector')
            // setSearchParams(searchParams);
            const hasFilter = showAll || activeSector;
            navigate(`/companies${(activeSector? `?sector=${activeSector}` : '')}${(showAll? `?show=all` : '')}${(hasFilter ? '&' : '?')}status=${item.value}`)
            /*
            setStatusDropdownValue(item.value)
            switch (item.value) {
                case 'Active':
                    setFilter((s) => {
                        // console.log("current state when showing active", s);
                        let temp = {
                            ...s
                        }
                        temp.alumni = false;
                        temp.investment_status = true;
                        
                        return temp;})
                    scrollToTop();
                    break;
                case 'Alumni':
                    setFilter((s) => {
                        // console.log("current state when showing alumni", s);
                        let temp = {
                            ...s
                        }
                        temp.alumni = true;
                        temp.investment_status = false;
                        
                        return temp;
                    })
                    scrollToTop();
                    break;
                default:
                    setFilter((s) => ({
                        ...initialState,
                    }))
                    scrollToTop();
                    break;
            }
            */
        }
    }));

   

    /*
         <Button
            onClick={() => {
                    setFilter((s) => ({
                        ...initialState,
                        alumni: !s['alumni'],
                    }))
                    scrollToTop();
                }
            }
            isActive={filter.alumni}
        >
            Alumni
        </Button>
    */

    
    return (
        <>
            <Box borderX={'1px'} borderColor={'brandAlpha.200'} className={'companies-filter'}>
                <Box position={'relative'}>
                    <Container>
                        <motion.div
                            initial={{y: 50, opacity: 0}}
                            animate={{y: 0, opacity: 1}}
                            transition={{
                                delay: 0.3,
                                default: {duration: 0.5},
                            }}
                        >
                            <Box pb={[view === 'grid' ? '30px' : '5px', '33px']} as="section">
                                <Box as="nav">
                                    <Flex px={['2.5', '5']} justify="space-between" wrap={'wrap'}>
                                        <ButtonGroup flexWrap={'wrap'} spacing="1">
                                            <Button
                                                onClick={() => {
                                                    searchParams.delete('sector')
                                                    // setSearchParams(searchParams);
                                                    setInitialDropdownValue(undefined)
                                                    setStatusDropdownValue(undefined)
                                                    setFilter(initialState);
                                                    scrollToTop();
                                                    setSearchParams({
                                                        show: 'all'
                                                    })
                                                }}
                                                display={['none', 'flex']}
                                                isActive={
                                                    !Object.values(filter)
                                                        .map((item) => !!item)
                                                        .includes(true)
                                                }
                                            >
                                                All
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                        searchParams.delete('sector')
                                                        setFilter((s) => ({
                                                            ...initialState,
                                                            featured: !s['featured'],
                                                        }))
                                                        setSearchParams({
                                                            
                                                        })
                                                        scrollToTop();
                                                    }
                                                }
                                                isActive={filter.featured}
                                                display={['none', 'flex']}
                                            >
                                                Featured
                                            </Button>
                                           
                                            <Box flexWrap={'wrap'} display={['block', 'flex']}>
                                                <MenuKit
                                                    gutter={20}
                                                    buttonProps={{
                                                        children: filter.technology || 'Technology',
                                                        isActive: filter.technology !== null,
                                                    }}
                                                    activeItem={filter.technology}
                                                    options={technologyDropdown}
                                                />
                                                <MenuKit
                                                    gutter={20}
                                                    buttonProps={{
                                                        children: filter.private_healthcare || 'Venture Healthcare',
                                                        isActive: filter.private_healthcare !== null,
                                                    }}
                                                    activeItem={filter.private_healthcare}
                                                    options={healthDropdown}
                                                />
                                            </Box>
                                        </ButtonGroup>
                                        <HStack spacing="2">
                                            <ButtonGroup display={['none','none','none', 'flex']} flexWrap={'wrap'} spacing="1">
                                                <MenuKit
                                                    gutter={20}
                                                    buttonProps={{
                                                        children: statusDropdownValue || 'Status',
                                                        isActive: filter.investment_status || filter.alumni,
                                                    }}
                                                    activeItem={filter.investment_status || filter.alumni}
                                                    options={statusDropdown}
                                                />
                                                <MenuKit
                                                    gutter={20}
                                                    buttonProps={{
                                                        children: (filter.firstInvestment !== null ? (filter.firstInvestment == 'Series B' ? 'Series B+' : filter.firstInvestment) : 'First Investment') ,
                                                        isActive: filter.firstInvestment !== null,
                                                    }}
                                                    activeItem={(filter.firstInvestment)}
                                                    options={firstInvestmentDropdown} 
                                                />
                                            </ButtonGroup>
                                            <>
                                                {!openFilter && (
                                                    <ButtonGroup display={{base: 'none', md: 'flex'}}>
                                                        <Button
                                                            iconSpacing={0}
                                                            size={'xs'}
                                                            leftIcon={<BsFillGridFill/>}
                                                            variant={'brand'}
                                                            borderRadius={'full'}
                                                            colorScheme={'brand'}
                                                            isActive={view === 'grid'}
                                                            onClick={() => setView('grid')}
                                                        />
                                                        <Button
                                                            iconSpacing={0}
                                                            size={'xs'}
                                                            leftIcon={<FaList/>}
                                                            variant={'brand'}
                                                            borderRadius={'full'}
                                                            colorScheme={'brand'}
                                                            onClick={() => setView('list')}
                                                            isActive={view === 'list'}
                                                        />
                                                    </ButtonGroup>
                                                )}
                                                {openFilter && (
                                                    <Button
                                                        size={'xs'}
                                                        variant={'solid'}
                                                        bgColor={brand700}
                                                        color={'white'}
                                                        onClick={() => setOpenFilter(false)}
                                                        iconSpacing={0}
                                                        borderRadius={'full'}
                                                    >
                                                        <CloseIcon/>
                                                    </Button>
                                                )}
                                            </>
                                        </HStack>
                                    </Flex>
                                    {openFilter && (
                                        <Flex px={'2.5'} wrap={'wrap'} gap={'15px'} mt={'15px'}>
                                            <MenuKit
                                                gutter={20}
                                                buttonProps={{
                                                    children: filter.technology || 'Technology',
                                                    size: 'sm',
                                                    py: '18px',
                                                    textColor: 'black',
                                                    fontWeight: 'semibold',
                                                    fontSize: 'xs',
                                                    variant: 'brand',
                                                    borderRadius: 'full',
                                                    colorScheme: 'brand',
                                                    borderColor: 'rgba(11, 46, 251, 0.5)',
                                                }}
                                                options={technologyDropdown}
                                                activeItem={filter.technology}
                                            />
                                            <MenuKit
                                                gutter={20}
                                                buttonProps={{
                                                    children: filter.private_healthcare || 'Private Healthcare',
                                                    size: 'sm',
                                                    py: '18px',
                                                    textColor: 'black',
                                                    fontWeight: 'semibold',
                                                    fontSize: 'xs',
                                                    variant: 'brand',
                                                    borderRadius: 'full',
                                                    colorScheme: 'brand',
                                                    borderColor: 'rgba(11, 46, 251, 0.5)',
                                                }}
                                                options={healthDropdown}
                                                activeItem={filter.private_healthcare}
                                            />

                                            <ButtonGroup spacing="3">
                                                <Button
                                                    size={'sm'}
                                                    py={'18px'}
                                                    textColor={'black'}
                                                    fontWeight={'semibold'}
                                                    fontSize={'xs'}
                                                    variant={'brand'}
                                                    borderRadius={'full'}
                                                    colorScheme={'brand'}
                                                    borderColor={'rgba(11, 46, 251, 0.5)'}
                                                    onClick={() =>
                                                        setFilter((s) => ({
                                                            ...initialState,
                                                            investment_status: !s['investment_status'],
                                                        }))
                                                    }
                                                    isActive={filter.investment_status}
                                                >
                                                    Active
                                                </Button>{' '}
                                                <Button
                                                    size={'sm'}
                                                    py={'18px'}
                                                    textColor={'black'}
                                                    fontWeight={'semibold'}
                                                    fontSize={'xs'}
                                                    variant={'brand'}
                                                    borderRadius={'full'}
                                                    colorScheme={'brand'}
                                                    borderColor={'rgba(11, 46, 251, 0.5)'}
                                                    onClick={() =>
                                                        setFilter((s) => ({
                                                            ...initialState,
                                                            alumni: !s['alumni'],
                                                        }))
                                                    }
                                                    isActive={filter.alumni}
                                                >
                                                    Alumni
                                                </Button>{' '}
                                                <MenuKit
                                                    gutter={20}
                                                    buttonProps={{
                                                        children: filter.firstInvestment || 'First Investment',
                                                        size: 'sm',
                                                        py: '18px',
                                                        textColor: 'black',
                                                        fontWeight: 'semibold',
                                                        fontSize: 'xs',
                                                        variant: 'brand',
                                                        borderRadius: 'full',
                                                        colorScheme: 'brand',
                                                        borderColor: 'rgba(11, 46, 251, 0.5)',
                                                        isActive: filter.firstInvestment !== null,
                                                    }}
                                                    options={firstInvestmentDropdown}
                                                    activeItem={filter.firstInvestment}
                                                />
                                            </ButtonGroup>
                                        </Flex>
                                    )}
                                </Box>
                            </Box>
                        </motion.div>
                    </Container>
                </Box>
            </Box>
        </>
    );
};

export default PortfolioNav;
export {companyViewState, companyFilterState};
